/// <reference types="dropzone/"/>
import { Directive, OnInit, Input, ElementRef, Output, EventEmitter } from '@angular/core';
declare var jQuery: any;

@Directive({
  selector: '[appDropzone]'
})

export class DropzoneDirective implements OnInit {
  @Input() private posturl: any;
  @Input() private headers: any;
  @Output() success = new EventEmitter();
  @Output() error = new EventEmitter();

  constructor(private el: ElementRef) { }

  ngOnInit() {
    debugger;
    const initDropzone = jQuery(this.el.nativeElement);
    initDropzone.dropzone({

      url: this.posturl,
      headers: this.headers,
      addRemoveLinks: false,
      //  uploadMultiple: false,
      //  autoProcessQueue: false, //

      success: (file, response) => {
        debugger;
        const eventArgs = {
          file: file,
          response: response
        };
        this.success.emit(eventArgs);
      },
      error: (file, errorMessage) => {
        const eventArgs = {
          file: file,
          errorMessage: errorMessage
        };
        this.error.emit(eventArgs);
      }
    });
  }
}
